import cdaXslUrl from "url:./cda.xsl";

function appendPreFallback(el, xmlText) {
  const pre = document.createElement("pre");
  pre.className = "whitespace-pre-wrap break-words rounded-md bg-gray-50 p-3 text-xs text-gray-800";
  pre.textContent = xmlText;
  el.appendChild(pre);
}

function hasXmlParserError(doc) {
  return doc.getElementsByTagName("parsererror").length > 0;
}

let xslCachePromise = null;

function loadXslText() {
  if (!xslCachePromise) {
    xslCachePromise = fetch(cdaXslUrl).then((res) => {
      if (!res.ok) {
        throw new Error("xsl fetch failed");
      }
      return res.text();
    });
  }
  return xslCachePromise;
}

const XmlPreviewPort = {
  add(app) {
    if (!app.ports.requestXmlPreview || !app.ports.xmlPreviewResult) {
      return;
    }

    app.ports.requestXmlPreview.subscribe(async ({ requestId, url, elementId }) => {
      const sendFail = () => {
        app.ports.xmlPreviewResult.send({ requestId, ok: false });
      };

      try {
        const el = document.getElementById(elementId);
        if (!el) {
          sendFail();
          return;
        }

        const res = await fetch(url);
        if (!res.ok) {
          sendFail();
          return;
        }

        const xmlText = await res.text();

        el.replaceChildren();

        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(xmlText, "application/xml");

        if (hasXmlParserError(xmlDoc)) {
          appendPreFallback(el, xmlText);
          app.ports.xmlPreviewResult.send({ requestId, ok: true });
          return;
        }

        try {
          const xslText = await loadXslText();
          const xsltProcessor = new XSLTProcessor();
          const xslDoc = parser.parseFromString(xslText, "application/xml");
          if (hasXmlParserError(xslDoc)) {
            throw new Error("Invalid XSL");
          }
          xsltProcessor.importStylesheet(xslDoc);
          const fragment = xsltProcessor.transformToFragment(xmlDoc, document);
          el.appendChild(fragment);
        } catch {
          appendPreFallback(el, xmlText);
        }

        app.ports.xmlPreviewResult.send({ requestId, ok: true });
      } catch {
        sendFail();
      }
    });

    if (app.ports.clearXmlMount) {
      app.ports.clearXmlMount.subscribe((elementId) => {
        if (!elementId) {
          return;
        }
        const mount = document.getElementById(elementId);
        if (mount) {
          mount.replaceChildren();
        }
      });
    }
  },
};

export default XmlPreviewPort;
